var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareVideoIconMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 12,
    fill: "#E0F0E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 27,
    height: 27,
    rx: 4.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 48,
    width: 27,
    height: 27,
    rx: 4.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 15,
    width: 27,
    height: 27,
    rx: 4.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.25,
    y: 50.25,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    fill: "#61B369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0318 59.4344C65.1219 59.4344 66 58.5568 66 57.4672C66 56.3777 65.1219 55.5 64.0318 55.5C62.9418 55.5 62.0637 56.3777 62.0637 57.4672C62.0637 57.7851 62.1394 58.1028 62.2907 58.36L59.5202 60.1305C59.172 59.8279 58.7178 59.6311 58.2182 59.6311C57.1281 59.6311 56.25 60.5088 56.25 61.5983C56.25 62.6879 57.1281 63.5656 58.2182 63.5656C58.7178 63.5656 59.172 63.3688 59.5202 63.0662L62.1999 64.7913C62.1091 65.0182 62.0485 65.2756 62.0485 65.5328C62.0485 66.6223 62.9266 67.5 64.0166 67.5C65.1067 67.5 65.9848 66.6223 65.9848 65.5328C65.9848 64.4433 65.1067 63.5656 64.0166 63.5656C63.517 63.5656 63.078 63.7471 62.7297 64.0498L60.05 62.3247C60.1408 62.0977 60.1862 61.8556 60.1862 61.5983C60.1862 61.3411 60.1408 61.099 60.05 60.872L62.8811 59.0562C63.1991 59.2982 63.5928 59.4345 64.0317 59.4345L64.0318 59.4344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22.7424C54 22.2374 54.1689 21.8207 54.5068 21.4924C54.8446 21.1641 55.2838 21 55.8243 21C56.3552 21 56.7847 21.1616 57.1129 21.4848C57.4508 21.8182 57.6197 22.2525 57.6197 22.7879C57.6197 23.2727 57.4556 23.6768 57.1274 24C56.7896 24.3333 56.3456 24.5 55.7954 24.5H55.7809C55.25 24.5 54.8205 24.3333 54.4923 24C54.1641 23.6667 54 23.2475 54 22.7424ZM54.1882 36V25.8788H57.4025V36H54.1882ZM59.1834 36H62.3977V30.3485C62.3977 29.9949 62.4363 29.7222 62.5135 29.5303C62.6486 29.1869 62.8538 28.8965 63.1289 28.6591C63.404 28.4217 63.749 28.303 64.1641 28.303C65.2452 28.303 65.7857 29.0657 65.7857 30.5909V36H69V30.197C69 28.702 68.6622 27.5682 67.9865 26.7955C67.3108 26.0227 66.418 25.6364 65.3079 25.6364C64.0627 25.6364 63.0927 26.197 62.3977 27.3182V27.3485H62.3832L62.3977 27.3182V25.8788H59.1834C59.2027 26.202 59.2124 27.2071 59.2124 28.8939C59.2124 30.5808 59.2027 32.9495 59.1834 36Z",
    fill: "#AEDACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 33.75C36 35.25 35.25 36 33.75 36H23.25C21.75 36 21 35.25 21 33.75V23.25C21 21.75 21.75 21 23.25 21H33.75C35.25 21 36 21.75 36 23.25V33.75ZM31.3492 30.1906V35.9996H29.0151V30.1906H27.0593V27.9263H29.0151V26.2558C29.0151 24.3175 30.1967 23.2639 31.9254 23.2639C32.752 23.2639 33.4621 23.3221 33.6717 23.3512V25.3827H32.4726C31.5296 25.3827 31.3492 25.825 31.3492 26.4828V27.9263H33.5902L33.2991 30.1906H31.3492Z",
    fill: "#AEDACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4391 68.25C31.6658 68.25 35.071 63.0567 35.071 58.5532C35.071 58.4057 35.068 58.2589 35.0614 58.1127C35.7239 57.6301 36.2958 57.0325 36.75 56.3479C36.1434 56.6194 35.4907 56.8021 34.806 56.8845C35.5049 56.4626 36.0414 55.7951 36.2946 54.9995C35.6301 55.3964 34.9031 55.6761 34.145 55.8268C33.5272 55.1643 32.6478 54.75 31.6739 54.75C29.8045 54.75 28.2885 56.2762 28.2885 58.1576C28.2885 58.425 28.3182 58.6851 28.3763 58.9347C25.5628 58.7921 23.0679 57.436 21.3982 55.3739C21.0975 55.894 20.9393 56.4851 20.9398 57.0868C20.9398 58.2692 21.5375 59.313 22.4463 59.9237C21.9087 59.9072 21.3829 59.761 20.9132 59.4974C20.9126 59.5118 20.9126 59.5257 20.9126 59.541C20.9126 61.1915 22.0795 62.5695 23.6285 62.8818C23.3376 62.9615 23.0374 63.0018 22.7359 63.0017C22.5181 63.0017 22.3059 62.9801 22.0996 62.9402C22.5306 64.2944 23.7803 65.2798 25.262 65.3073C24.1034 66.2216 22.6438 66.7661 21.0575 66.7661C20.7876 66.7663 20.518 66.7506 20.25 66.7189C21.7482 67.6857 23.5272 68.2498 25.4392 68.2498",
    fill: "#AEDACA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareVideoIconMax);
export default __webpack_public_path__ + "static/media/shareVideoIconMax.c87cc934.svg";
export { ForwardRef as ReactComponent };